import { render } from "./Todo.vue?vue&type=template&id=71902966&ts=true"
import script from "./Todo.vue?vue&type=script&lang=ts"
export * from "./Todo.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__